import PropTypes from 'prop-types'

import { scribble2, explainerLeftBackground } from 'resources/images'

import { LeftSideBackground, ImageIconContainer, IconTextContainer, TopUnveilScribble } from './styles'

const AttributesCounterComponent = ({ children = null }) => (
  <ImageIconContainer>
    <LeftSideBackground background={explainerLeftBackground}>
      <TopUnveilScribble src={scribble2} />
      <IconTextContainer>{children}</IconTextContainer>
    </LeftSideBackground>
  </ImageIconContainer>
)

AttributesCounterComponent.propTypes = {
  children: PropTypes.node,
}

export default AttributesCounterComponent
